import waves from './waves'

export default {
  install (Vue) {
    Vue.directive('waves', waves)
  }
}
